import FormattedText from './FormattedText';
import RichTextPreview from './RichTextPreview';
import React from 'react';
import moment from 'moment';
import { MdEdit } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import { Status } from './Feedback';

export default function SelectionSummary({ selection, onEdit, allowed }) {
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <div className="module-content-heading">
            <h2>Informações e período</h2>
            <p>Publicação, prazo e condições das inscrições.</p>
          </div>
          <DefaultButton
            text="Editar configuração"
            bg="info"
            icon={<MdEdit />}
            onClick={onEdit}
            disabled={!allowed}
          />
        </div>
        {selection.enabled === false && (
          <div className="alert alert-warning" role="status">
            Este seletivo está com as inscrições desabilitadas na OnTest e não aparece no portal,
            mesmo que esteja publicado. Clique em Editar configuração para habilitar as inscrições.
          </div>
        )}
        <dl className="portal-admin-facts">
          <div>
            <dt>Nome para publicação</dt>
            <dd><FormattedText>{selection.title}</FormattedText></dd>
          </div>
          <div>
            <dt>Situação</dt>
            <dd>
              <Status value={selection.status} />
            </dd>
          </div>
          <div>
            <dt>Início das inscrições</dt>
            <dd>{moment(selection.registration_starts_at).format('DD/MM/YYYY HH:mm')}</dd>
          </div>
          <div>
            <dt>Fim das inscrições</dt>
            <dd>{moment(selection.registration_ends_at).format('DD/MM/YYYY HH:mm')}</dd>
          </div>
          <div>
            <dt>Análise das inscrições</dt>
            <dd>{selection.requires_review ? 'Aguarda análise' : 'Deferimento ao confirmar'}</dd>
          </div>
          <div>
            <dt>Cancelamento pelo candidato</dt>
            <dd>
              {selection.allow_cancellation ? 'Permitido antes da vinculação' : 'Desabilitado'}
            </dd>
          </div>
        </dl>
        <p className="portal-admin-prose"><FormattedText>{selection.description}</FormattedText></p>
        <details className="portal-operation">
          <summary>Condições para inscrição e cronograma</summary>
          <div className="portal-operation-content">
            <RichTextPreview html={selection.terms} />
            {selection.schedule?.map((item, index) => (
              <p key={index}>
                <strong><FormattedText>{item.date}</FormattedText></strong> · <FormattedText>{item.title}</FormattedText>
              </p>
            ))}
          </div>
        </details>
      </div>
    </section>
  );
}
